export default {
  TITLE: '应用权限说明',
  CONTENT: `
    <h3>安卓操作系统应用权限</h3>
    <table>
      <tr>
        <th>权限名称</th>
        <th>功能说明</th>
        <th>使用场景</th>
      </tr>
      <tr>
        <td>INTERNET</td>
        <td>允许应用联网和发送统计数据</td>
        <td>推送通知，talkingdata埋点</td>
      </tr>
      <tr>
        <td>ACCESS_NETWORK_STATE</td>
        <td>允许应用检测网络连接状态,在网络异常状态下暂停数据发送</td>
        <td>推送通知，talkingdata埋点</td>
      </tr>
      <tr>
        <td>ACCESS_WIFI_STATE</td>
        <td>获取设备的MAC地址,同样用来标识唯一用户</td>
        <td>推送通知，talkingdata埋点</td>
      </tr>
      <tr>
        <td>VIBRATE</td>
        <td>震动权限（使用通知功能必选）</td>
        <td>推送通知</td>
      </tr>
      <tr>
        <td>GET_TASKS</td>
        <td>获取任务信息，目的是防止sdk被频繁唤醒</td>
        <td>推送通知</td>
      </tr>
      <tr>
        <td>SCHEDULE_EXACT_ALARM</td>
        <td>兼容android12 alarm权限</td>
        <td>推送通知</td>
      </tr>
      <tr>
        <td>BADGE_ICON</td>
        <td>vivo角标设置</td>
        <td>推送通知</td>
      </tr>
      <tr>
        <td>READ PHONE STATE</td>
        <td>
          允许应用以只读的方式访问手机设备的信息,通过获取的信息来唯一标识用户
        </td>
        <td>talkingdata埋点</td>
      </tr>
      <tr>
        <td>WRITE EXTERNAL STORAGE</td>
        <td>用于保存设备信息,以及记录日志;保存海报到本地相册</td>
        <td>talkingdata埋点，分享</td>
      </tr>
      <tr>
        <td>READ_CLIPBOARD</td>
        <td>读取剪切板信息</td>
        <td>PAKOL</td>
      </tr>
      <tr>
        <td>READ_EXTERNAL_STORAGE</td>
        <td>读取相册信息用于上传图片</td>
        <td>清关信息页面填写上传身份证照片</td>
      </tr>
      <tr>
        <td>MANAGE_ACCOUNTS</td>
        <td>用于指示应用程序具有管理账户的能力。当应用程序需要创建、修改或删除用户的账户信息时，它们需要声明这个权限</td>
        <td>登陆注册</td>
      </tr>
      <tr>
        <td>USE_CREDENTIALS</td>
        <td>允许应用程序请求验证从AccountManager的authtoken</td>
        <td>登陆注册</td>
      </tr>
      <tr>
        <td>GET_ACCOUNTS</td>
        <td>允许应用程序访问设备上的账户信息</td>
        <td>登陆注册</td>
      </tr>
      <tr>
        <td>AUTHENTICATE_ACCOUNTS</td>
        <td>用于指示应用程序具有验证账户的能力</td>
        <td>登陆注册</td>
      </tr>
    </table>
    <h3>IOS操作系统应用权限</h3>
    <table>
      <tr>
        <th>权限名称</th>
        <th>功能说明</th>
        <th>使用场景</th>
        <th>内容是否支持自定义</th>
        <th>弹窗内容</th>
      </tr>
      <tr>
        <td>Privacy - Photo Library Additions Usage Description</td>
        <td>保存图片到相册</td>
        <td>商品详情页点击分享按钮，保存海报到相册</td>
        <td>是</td>
        <td>只有你允许保存照片的程序和功能才能使用它。例如:保存海报</td>
      </tr>
      <tr>
        <td>Privacy - Camera Usage Description</td>
        <td>相机功能</td>
        <td>KYC上传图片</td>
        <td>是</td>
        <td>只有你允许使用相机的程序和功能才能使用它。例如:选择身份证图片上传</td>
      </tr>
      <tr>
        <td>Privacy - Photo Library Usage Description</td>
        <td>相册</td>
        <td>KYC上传图片</td>
        <td>是</td>
        <td>只有你允许使用相册的程序和功能才能使用它。例如:选择身份证图片上传</td>
      </tr>
      <tr>
        <td>Privacy - Tracking Usage Description</td>
        <td>IDFA</td>
        <td>TalkingDataSDK使用</td>
        <td>是</td>
        <td>获取设备信息用以精准推送您喜欢的内容</td>
      </tr>
      <tr>
        <td>Push</td>
        <td>消息推送</td>
        <td>消息推送</td>
        <td>否</td>
        <td>
          <img class="img-round" src="https://m.media-amazon.com/images/G/28/GlobalStoreMobileShoppingWebapp/assets/image/protocol/permission_description_push.jpg" alt="" />
        </td>
      </tr>
      <tr>
        <td>剪切板</td>
        <td>获取剪切板内容</td>
        <td>未安装app时的D e e p Li n k</td>
        <td>否</td>
        <td>
          <img class="img-round" src="https://m.media-amazon.com/images/G/28/GlobalStoreMobileShoppingWebapp/assets/image/protocol/permission_description_clipBoard.jpg" alt="" />
        </td>
      </tr>
      <tr>
        <td>Access WiFi Information</td>
        <td>获取Wifi信息</td>
        <td>TalkingDataSDK归因</td>
        <td>-</td>
        <td>无弹窗（暂时不能确认）</td>
      </tr>
      <tr>
        <td>Privacy - Location When In Use Usage Description</td>
        <td>获取定位权限</td>
        <td>TalkingDataSDK归因需要获取Wifi信息。iOS13之后，获取Wifi信息，需要开启定位权限。</td>
        <td>是</td>
        <td>获取wifi信息需要开启定位权限</td>
      </tr>
    </table>
  `
};
